type TranslationOptions = Record<string, unknown> & { defaultValue?: string };

const translations = {
  "pt-BR": {
    noDate: "Sem data",
    patient: "Paciente",
    owner: "Responsável",
    species: "Espécie",
    weight: "Peso",
    weightKilograms: "{{weight}} kg",
    gender: "Sexo",
    breed: "Raça",
    age: "Idade",
    composition: "Composição",
    veterinarian: "Veterinário",
    clinic: "Clínica",
    issueDate: "Data de Emissão",
    mapaPrescriptionIdentifier: "Nº da prescrição MAPA",
    crmvParenLabel: "CRMV {{crmv}}",
    validUntil: "Válida até",
    title: "RECEITUÁRIO",
    examRequest: "SOLICITAÇÃO DE EXAMES",
    exams: "Exames:",
    medications: "Medicamentos:",
    presentation: "Apresentação",
    dosage: "Dosagem",
    route: "Via",
    frequency: "Frequência",
    duration: "Duração",
    quantity: "Quantidade",
    medicationQuantityFormat: "{{medication}} - {{quantity}}",
    posologyEvery: "a cada {{value}} {{unit}}",
    posologyFor: "por {{value}} {{unit}}",
    posologyAutomaticSentence: "Dar {{dose}}{{frequency}}{{duration}}",
    posologyDoseFallback: "conforme orientação",
    instructions: "Instruções",
    observations: "Observações",
    responsibleVet: "Veterinário Responsável",
    noPosology: "Posologia não informada.",
    manipulatedTitle: "Fórmula manipulada:",
    treatmentDays: "Tempo de tratamento (dias)",
    totalDoses: "Quantidade total de doses",
    patientInfoTitle: "Informações do animal e do responsável",
    issuerInfoTitle: "Identificação do emitente",
    prescriptionSectionTitle: "Prescrição",
    address: "Endereço",
    phone: "Telefone",
    ownerDocument: "CPF do responsável",
    titleControlled: "RECEITUÁRIO DE CONTROLE ESPECIAL",
    titleManipulated: "RECEITUÁRIO — FÓRMULA MANIPULADA",
    viaOrdinal1: "1ª via",
    viaOrdinal2: "2ª via",
    viaOrdinal3: "3ª via",
    viaPurposeViaPharmacy: "retenção da farmácia",
    viaPurposeViaResponsible: "orientação ao responsável",
    viaPurposeViaEstablishment: "estabelecimento manipulador",
    viaPurposeViaVeterinarian: "veterinário",
    issuerLabel: "EMITENTE",
    patientLabel: "PACIENTE",
    ownerLabel: "RESPONSÁVEL",
    cpfLabel: "CPF",
    bornShort: "nasc. {{date}}",
    mapaShort: "MAPA",
    crmvShort: "CRMV",
    routeSection: "USO {{route}}",
    prescriptionSection: "PRESCRIÇÃO",
    pharmaceuticalFormSuffix: "forma farmacêutica",
    compositionPerDose: "Composição (por dose)",
    treatmentDaysBox: "Tempo de tratamento",
    totalDosesBox: "Quantidade total",
    routeBox: "Via",
    daysValue: "{{count}} dias",
    dosesValue: "{{count}} doses",
    instructionsLabel: "Modo de usar:",
    guidanceLabel: "Orientações:",
    guidanceExamLabel: "Orientações complementares:",
    validUntilShort: "válida até {{date}}",
    mapaRegistryLine: "Registro no MAPA {{value}}",
    mapaSequenceLine: "Nº da receita MAPA: <b>{{value}}</b>",
    buyerTitle: "IDENTIFICAÇÃO DO <b>COMPRADOR</b>",
    supplierTitle: "IDENTIFICAÇÃO DO <b>FORNECEDOR</b>",
    buyerName: "Nome:",
    buyerDocument: "CPF/CNPJ:",
    buyerAddress: "Endereço:",
    buyerCity: "Cidade/UF:",
    buyerPhone: "Telefone:",
    supplierDate: "Data:",
    pharmacistSignature: "Assinatura do farmacêutico",
    draftBadge: "PRÉVIA",
    "vias.viaResponsible": "VIA DO RESPONSÁVEL",
    "vias.viaPharmacy": "VIA DA FARMÁCIA",
    "vias.viaEstablishment": "VIA DO ESTABELECIMENTO",
    "vias.viaVeterinarian": "VIA DO VETERINÁRIO",
    "vias.copyNofM": "Via {{n}} de {{total}}",
    "vias.pageNofM": "Página {{n}} de {{total}}",
    "digitalSeal.sampleDetails": "Assinado em 02/10/2026 às 14:32:07 por {{vet}} - {{crmv}} para {{owner}} em {{clinic}}.",
    "digitalSeal.scanInstruction": "Escaneie o QR Code ao lado para baixar o PDF e valide em",
    "digitalSeal.qrDemo": "QR Code demonstrativo de validação",
  },
  en: {
    noDate: "No date",
    patient: "Patient",
    owner: "Owner",
    species: "Species",
    weight: "Weight",
    weightKilograms: "{{weight}} kg",
    gender: "Gender",
    breed: "Breed",
    age: "Age",
    composition: "Composition",
    veterinarian: "Veterinarian",
    clinic: "Clinic",
    issueDate: "Issue Date",
    mapaPrescriptionIdentifier: "MAPA prescription number",
    crmvParenLabel: "CRMV {{crmv}}",
    validUntil: "Valid until",
    title: "PRESCRIPTION",
    examRequest: "EXAM REQUEST",
    exams: "Exams:",
    medications: "Medications:",
    presentation: "Presentation",
    dosage: "Dosage",
    route: "Route",
    frequency: "Frequency",
    duration: "Duration",
    quantity: "Quantity",
    medicationQuantityFormat: "{{medication}} - {{quantity}}",
    posologyEvery: "every {{value}} {{unit}}",
    posologyFor: "for {{value}} {{unit}}",
    posologyAutomaticSentence: "Give {{dose}}{{frequency}}{{duration}}",
    posologyDoseFallback: "as directed",
    instructions: "Instructions",
    observations: "Observations",
    responsibleVet: "Responsible Veterinarian",
    noPosology: "Dosage not provided.",
    manipulatedTitle: "Compounded formula:",
    treatmentDays: "Treatment duration (days)",
    totalDoses: "Total number of doses",
    patientInfoTitle: "Animal and owner information",
    issuerInfoTitle: "Issuer identification",
    prescriptionSectionTitle: "Prescription",
    address: "Address",
    phone: "Phone",
    ownerDocument: "Owner CPF",
    titleControlled: "SPECIAL CONTROL PRESCRIPTION",
    titleManipulated: "PRESCRIPTION — COMPOUNDED FORMULA",
    viaOrdinal1: "1st copy",
    viaOrdinal2: "2nd copy",
    viaOrdinal3: "3rd copy",
    viaPurposeViaPharmacy: "kept by the pharmacy",
    viaPurposeViaResponsible: "owner instructions",
    viaPurposeViaEstablishment: "compounding pharmacy",
    viaPurposeViaVeterinarian: "veterinarian",
    issuerLabel: "ISSUER",
    patientLabel: "PATIENT",
    ownerLabel: "OWNER",
    cpfLabel: "Tax ID",
    bornShort: "born {{date}}",
    mapaShort: "MAPA",
    crmvShort: "CRMV",
    routeSection: "{{route}} USE",
    prescriptionSection: "PRESCRIPTION",
    pharmaceuticalFormSuffix: "dosage form",
    compositionPerDose: "Composition (per dose)",
    treatmentDaysBox: "Treatment length",
    totalDosesBox: "Total quantity",
    routeBox: "Route",
    daysValue: "{{count}} days",
    dosesValue: "{{count}} doses",
    instructionsLabel: "Directions:",
    guidanceLabel: "Instructions:",
    guidanceExamLabel: "Additional instructions:",
    validUntilShort: "valid until {{date}}",
    mapaRegistryLine: "MAPA registration {{value}}",
    mapaSequenceLine: "MAPA prescription no.: <b>{{value}}</b>",
    buyerTitle: "BUYER <b>IDENTIFICATION</b>",
    supplierTitle: "SUPPLIER <b>IDENTIFICATION</b>",
    buyerName: "Name:",
    buyerDocument: "Tax ID:",
    buyerAddress: "Address:",
    buyerCity: "City/State:",
    buyerPhone: "Phone:",
    supplierDate: "Date:",
    pharmacistSignature: "Pharmacist signature",
    draftBadge: "PREVIEW",
    "vias.viaResponsible": "OWNER'S COPY",
    "vias.viaPharmacy": "PHARMACY COPY",
    "vias.viaEstablishment": "ESTABLISHMENT COPY",
    "vias.viaVeterinarian": "VETERINARIAN'S COPY",
    "vias.copyNofM": "Copy {{n}} of {{total}}",
    "vias.pageNofM": "Page {{n}} of {{total}}",
    "digitalSeal.sampleDetails": "Signed on 10/02/2026 at 2:32:07 PM by {{vet}} - {{crmv}} for {{owner}} at {{clinic}}.",
    "digitalSeal.scanInstruction": "Scan the QR Code to download the PDF and validate it at",
    "digitalSeal.qrDemo": "Sample validation QR Code",
  },
} as const;

function interpolate(template: string, options: TranslationOptions): string {
  return template.replace(/\{\{(\w+)\}\}/g, (_, key: string) => String(options[key] ?? ""));
}

export function createPrintTranslator(lang: "pt-BR" | "en") {
  return (key: string, options: TranslationOptions = {}): string => {
    const subKey = key.replace(/^print\./, "") as keyof typeof translations[typeof lang];
    const template = translations[lang][subKey] ?? options.defaultValue ?? key;
    return interpolate(template, options);
  };
}
